module.exports = __webpack_public_path__ + "static/media/masterDev-logo-min.17381d63.svg";